import store from '../store/index'
import normalizeCombatLookupImage from './normalizeCombatLookupImage'
//------------------
// get marker image
//------------------
export default function getMarkerImage(this_marker) {
  //-----------------
  // get all markers
  //-----------------
  const this_store = store
  const markers = this_store.getters['combat/getMarkers'] || []
  //-------------------------
  // get matching marker obj
  //-------------------------
  let obj = markers.find((a) => a.name == this_marker)
  return obj ? normalizeCombatLookupImage(obj.image) : null
}
